<template lang="pug">
  modal(v-bind="$attrs" title="Meu QR code" @close="$emit('close')")
    div(slot="modal-body")
      .columns.flex-centered
        .column.flex-centered
          img.scan-qr(:src="require('@/assets/scan-qr.gif')")
        .column.flex-centered
          qr(:text="link")
      .mt-2.pt-2
        .divider
        div Este é o #[span.text-error seu QR code]
        div
          cite.text-small O afiliado pode escaneá-lo para ser vinculado a você
</template>

<script>
import Qr from 'vue-qrcode-component'

export default {
  components: { Qr },
  props: {
    link: { type: String, required: true },
  },
}
</script>

<style lang="stylus" scoped>
.scan-qr
  max-width 150px
</style>
